import React, { useContext } from 'react';
import { bool } from 'prop-types';

import useStyles from 'hooks/useStyles';
import CourseContext from '../CourseContext';
import CategoryLessons from '../CategoryLessons';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './TrailerLessonItem.scss';

function TrailerLessonItem({ show }) {
  useStyles(styles);

  const { trailerLesson } = useContext(CourseContext);

  if (!trailerLesson || !show) return null;

  return <CategoryLessons className={styles.root} list={[trailerLesson]} />;
}

TrailerLessonItem.propTypes = {
  show: bool,
};

TrailerLessonItem.defaultProps = {
  show: true,
};

export default TrailerLessonItem;
